export const HighlightedIconSilver = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" {...props}>
    <path
      d="m64.09 4.51 8.55 1.43c20.41 4.69 36.76 21.37 41.05 41.87l1.26 8.16v6.47l-.93 6.52c-11.24 57.93-92.92 59.92-106.96 2.59L5.63 63c.13-2.48-.17-5.13 0-7.59 1.9-26.78 24-49 50.87-50.9h7.59Z"
      style={{
        fill: "#8d8d8d",
      }}
    />
    <path
      d="m64.65 32.93 3.65 11.24a4.609 4.609 0 0 0 4.37 3.18h11.82c4.45 0 6.31 5.7 2.7 8.32l-9.56 6.95a4.594 4.594 0 0 0-1.67 5.14L79.61 79c1.38 4.24-3.47 7.76-7.08 5.14l-9.56-6.95a4.608 4.608 0 0 0-5.41 0L48 84.14c-3.6 2.62-8.45-.9-7.08-5.14l3.65-11.24c.62-1.89-.06-3.97-1.67-5.14l-9.56-6.95c-3.6-2.62-1.75-8.32 2.7-8.32h11.82c1.99 0 3.76-1.28 4.37-3.18l3.65-11.24c1.38-4.24 7.37-4.24 8.75 0h.02Z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
)